import { Injectable, NgModuleFactoryLoader, Injector, Input, ViewContainerRef, SystemJsNgModuleLoader, Compiler, Inject, NgModuleFactory, ViewRef, ElementRef, ComponentRef } from '@angular/core';
import { NgxCmModalContext, NgxCmComponentInput, NgxCmComponentOutput, NgxCmModuleInfo } from '../models';
import { NGX_CM_MODULE_LOADER_REGISTRY } from '../_internals';
import { ComponentFactory, ComponentFactoryResolver } from '@angular/core';
import { NgxModalContainerComponent } from '../ngx-cm-components/ngx-modal-container/ngx-modal-container.component';
import { Observable } from 'rxjs';
import { NgxComponentService } from './ngx-component.service';

@Injectable()
export class NgxComponentInternalService extends NgxComponentService {
  public container: ViewContainerRef;

  constructor(
    private _ngModuleFactoryLoaderInternal: NgModuleFactoryLoader,
    private _compilerInternal: Compiler,
    private _injectorInternal: Injector,
    private _componentFactoryResolverInternal: ComponentFactoryResolver,
    @Inject(NGX_CM_MODULE_LOADER_REGISTRY) private _moduleRegistryInternal: NgxCmModuleInfo[]
  ) {
    super(
      _ngModuleFactoryLoaderInternal,
      _compilerInternal,
      _injectorInternal,
      _componentFactoryResolverInternal,
      _moduleRegistryInternal
    );
  }

}
